import React from "react";
import { GlowingEffect } from "../ui/glowing-effect";
import { useLang } from "../../context/LanguageContext";
import { t } from "../../translations";

export default function About() {
    const { lang } = useLang();
    const tr = t[lang].about;

    return (
        <section
            id="about"
            className="w-full bg-surface transition-colors duration-200"
        >
            <div className="max-w-4xl mx-auto pt-8 sm:pt-12 md:pt-16 px-3 sm:px-6 md:px-12 pb-8 sm:pb-12 md:pb-16 relative">
                {/* Decorative background shapes */}
                <div className="absolute -top-8 -left-8 w-24 h-24 bg-blue-300/10 rounded-full blur-3xl -z-10" />
                <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-purple-300/10 rounded-full blur-3xl -z-10" />
                <div className="relative bg-surface-elevated rounded-3xl shadow-card p-5 sm:p-6 md:p-10 z-10 border border-separator overflow-hidden group">
                    <GlowingEffect
                        spread={70}
                        glow={false}
                        disabled={false}
                        proximity={120}
                        inactiveZone={0.01}
                        borderWidth={3}
                        blur={4}
                    />
                    <div className="flex flex-col items-center md:items-start gap-8 relative z-10">
                        {/* Section Title */}
                        <div className="w-full flex flex-col items-center md:items-start">
                            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-label mb-2">
                                {tr.title}
                            </h2>
                            <div className="h-1 w-20 bg-gradient-to-r from-blue-600 to-purple-600 dark:from-blue-500 dark:to-purple-500 rounded-full" />
                        </div>

                        {/* Content Grid */}
                        <div className="grid md:grid-cols-2 gap-8 w-full">
                            {/* Main Description */}
                            <div className="space-y-6">
                                <p className="text-[17px] text-label-secondary leading-relaxed">{tr.p1}</p>
                                <p className="text-[17px] text-label-secondary leading-relaxed">{tr.p2}</p>
                            </div>

                            {/* Quick Facts */}
                            <div className="space-y-6">
                                <div className="space-y-4">
                                    {tr.facts.map((fact) => (
                                        <div key={fact} className="flex items-center space-x-3 text-label-secondary">
                                            <div className="w-1.5 h-1.5 rounded-full bg-accent" />
                                            <span className="text-[17px]">{fact}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
